import type { Finding } from "./Finding";

// У находок есть важность. У разборов, сделанных до её появления, `impact` у всех 0 —
// тогда экран выбирает главное по оценке, как раньше.
export const hasImpact = (findings: readonly Finding[]): boolean =>
  findings.some((finding) => finding.impact > 0);
